import React from "react";

export function IconStar() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99872 0.833008C10.3159 0.833008 10.6056 1.01307 10.746 1.29749L13.1273 6.12173L18.4526 6.9001C18.7664 6.94597 19.0269 7.16597 19.1248 7.46765C19.2226 7.76932 19.1407 8.10036 18.9135 8.32164L15.0608 12.0741L15.9701 17.3755C16.0237 17.6881 15.8951 18.0041 15.6385 18.1906C15.3819 18.377 15.0416 18.4016 14.7608 18.2539L9.99872 15.7495L5.2366 18.2539C4.95583 18.4016 4.61559 18.377 4.35894 18.1906C4.10229 18.0041 3.97376 17.6881 4.02738 17.3755L4.93662 12.0741L1.08394 8.32164C0.856763 8.10036 0.774869 7.76932 0.872684 7.46765C0.970498 7.16597 1.23107 6.94597 1.54487 6.9001L6.87017 6.12173L9.25146 1.29749C9.39186 1.01307 9.68154 0.833008 9.99872 0.833008ZM9.99872 3.54905L8.17098 7.25186C8.04969 7.49757 7.81537 7.66795 7.54424 7.70758L3.45573 8.30518L6.4135 11.186C6.61006 11.3775 6.69978 11.6534 6.6534 11.9239L5.95554 15.9927L9.61084 14.0704C9.85366 13.9427 10.1438 13.9427 10.3866 14.0704L14.0419 15.9927L13.344 11.9239C13.2977 11.6534 13.3874 11.3775 13.5839 11.186L16.5417 8.30518L12.4532 7.70758C12.1821 7.66795 11.9477 7.49757 11.8265 7.25186L9.99872 3.54905Z"
        fill="white"
      />
    </svg>
  );
}
